export default "__VITE_ASSET__CFsXtOYZ__"